import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { Typography, withStyles, createStyles, WithStyles, Theme } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';

const Transition = React.forwardRef<unknown, TransitionProps>(function Transition(props, ref) {
    // @ts-ignore
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps extends WithStyles<typeof STYLES> {
    openState: boolean
    onClose?: () => void
    title?: string
    message?: string
    onAgree: () => void
}

class ConfirmationDialog extends Component<IProps> {
    render() {
        const { openState = false, classes } = this.props;
        return (
            <div>
                <Dialog
                    open={openState}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.props.onClose}
                    classes={{
                        paper: classes.root
                    }}
                >
                    <DialogTitle>
                        {this.props.title || ''}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>{this.props.message}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.onAgree} color="primary">
                            Yes
                        </Button>
                        <Button onClick={this.props.onClose} color="secondary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const STYLES = (theme: Theme) => createStyles({
    root: {
        width: 400
    }
})

export default withStyles(STYLES)(ConfirmationDialog);